// Mock data for HPD landing page

export const heroData = {
  title: "Hope for Peace and Development",
  subtitle: "Autonomiser les femmes, construire la paix",
  description: "Une organisation féminine engagée pour un avenir stable et prospère en République Démocratique du Congo.",
  image: "https://images.unsplash.com/photo-1610626294778-86570f49140d",
  cta: {
    primary: "Découvrir nos actions",
    secondary: "Nous contacter"
  }
};

export const missionData = {
  title: "Notre Mission",
  description: "Hope for Peace and Development (HPD) est une organisation féminine engagée pour un avenir stable et prospère en République Démocratique du Congo. Basée à Bunia, en Ituri, notre association œuvre sans relâche pour transformer les défis en opportunités de développement. Nous croyons fermement que l'autonomisation des femmes et de la communauté entière ainsi que la protection des plus vulnérables sont les piliers d'une paix durable.",
  values: [
    {
      id: 1,
      title: "Autonomisation",
      description: "Renforcer les capacités des femmes et de la communauté entière pour qu'elles deviennent actrices de leur propre développement",
      icon: "Users"
    },
    {
      id: 2,
      title: "Paix Durable",
      description: "Construire une paix qui s'enracine dans la justice sociale et l'équité",
      icon: "Heart"
    },
    {
      id: 3,
      title: "Protection",
      description: "Protéger les plus vulnérables et garantir leurs droits fondamentaux",
      icon: "Shield"
    },
    {
      id: 4,
      title: "Développement",
      description: "Transformer les défis en opportunités de croissance durable",
      icon: "TrendingUp"
    }
  ]
};

export const programsData = {
  title: "Nos Programmes",
  subtitle: "Des actions concrètes pour un changement durable",
  programs: [
    {
      id: 1,
      title: "Éducation et Formation",
      description: "Programmes d'alphabétisation et de formation professionnelle pour les femmes et les jeunes filles",
      image: "https://images.unsplash.com/photo-1544928147-79a2dbc1f389",
      impact: "500+ femmes formées"
    },
    {
      id: 2,
      title: "Entrepreneuriat Féminin",
      description: "Soutien aux initiatives économiques des femmes et de la communauté entière à travers le microfinancement et le mentorat",
      image: "https://images.unsplash.com/photo-1622720110672-0049390839c9",
      impact: "200+ entreprises lancées"
    },
    {
      id: 3,
      title: "Consolidation de la Paix",
      description: "Médiation communautaire et programmes de réconciliation pour une paix durable",
      image: "https://images.unsplash.com/photo-1522543558187-768b6df7c25c",
      impact: "1000+ personnes touchées"
    },
    {
      id: 4,
      title: "Protection et Assistance",
      description: "Assistance juridique et psychosociale pour les femmes victimes de violences",
      image: "https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca",
      impact: "300+ femmes assistées"
    }
  ]
};

export const impactData = {
  title: "Notre Impact",
  subtitle: "Des résultats concrets sur le terrain",
  image: "https://images.unsplash.com/photo-1491438590914-bc09fcaaf77a",
  stats: [
    {
      id: 1,
      number: "2000+",
      label: "Bénéficiaires directs",
      icon: "Users"
    },
    {
      id: 2,
      number: "15",
      label: "Communautés touchées",
      icon: "MapPin"
    },
    {
      id: 3,
      number: "500+",
      label: "Femmes autonomisées",
      icon: "Award"
    },
    {
      id: 4,
      number: "50+",
      label: "Projets réalisés",
      icon: "CheckCircle"
    }
  ]
};

export const testimonialsData = {
  title: "Témoignages",
  subtitle: "Ils parlent de nous",
  background: "https://images.unsplash.com/photo-1610626295085-aa8d6ae8daec",
  testimonials: [
    {
      id: 1,
      name: "Marie Kabila",
      role: "Bénéficiaire - Programme Entrepreneuriat",
      content: "Grâce à HPD, j'ai pu lancer ma petite entreprise de couture. Aujourd'hui, je subviens aux besoins de ma famille et j'emploie trois autres femmes de ma communauté.",
      image: "https://images.unsplash.com/photo-1610626294775-6fe672afb6af"
    },
    {
      id: 2,
      name: "Jeanne Muhindo",
      role: "Participante - Programme de Paix",
      content: "Les sessions de médiation ont transformé notre village. Nous avons appris à résoudre nos conflits pacifiquement et à vivre ensemble en harmonie.",
      image: "https://images.unsplash.com/photo-1610626294778-86570f49140d"
    },
    {
      id: 3,
      name: "Grace Ndaya",
      role: "Formatrice - Programme Éducation",
      content: "J'ai suivi la formation d'alphabétisation et maintenant j'enseigne à d'autres femmes. L'éducation nous donne le pouvoir de changer nos vies.",
      image: "https://images.unsplash.com/photo-1544928147-79a2dbc1f389"
    }
  ]
};

export const contactData = {
  title: "Contactez-nous",
  subtitle: "Ensemble, construisons un avenir meilleur",
  info: {
    address: "Bunia, Ituri, République Démocratique du Congo",
    email: "contact@hpd-rdc.org",
    phone: "+243 823 665 173"
  },
  socialMedia: [
    { id: 1, platform: "Facebook", url: "#", icon: "Facebook" },
    { id: 2, platform: "Twitter", url: "#", icon: "Twitter" },
    { id: 3, platform: "Instagram", url: "#", icon: "Instagram" }
  ]
};

export const interventionsData = {
  title: "Nos Axes d'Intervention",
  subtitle: "L'action de HPD s'articule autour de cinq engagements majeurs pour un impact réel sur le terrain",
  pillars: [
    {
      id: 1,
      title: "Paix et Médiation",
      description: "Nous intervenons dans la transformation des conflits et la prévention des violences pour consolider la cohésion sociale.",
      icon: "Handshake",
      color: "from-emerald-500 to-teal-600",
      image: "https://images.unsplash.com/photo-1522543558187-768b6df7c25c"
    },
    {
      id: 2,
      title: "Enfance et Éducation",
      description: "Nous veillons à la protection, la nutrition et la santé des enfants, ainsi qu'à l'accompagnement des mères.",
      icon: "GraduationCap",
      color: "from-blue-500 to-cyan-600",
      image: "https://images.unsplash.com/photo-1544928147-79a2dbc1f389"
    },
    {
      id: 3,
      title: "Genre et Autonomisation",
      description: "Nous luttons contre les violences basées sur le genre et soutenons l'indépendance économique et civique des femmes et de la communauté entière.",
      icon: "Users",
      color: "from-purple-500 to-indigo-600",
      image: "https://images.unsplash.com/photo-1610626294778-86570f49140d"
    },
    {
      id: 4,
      title: "Leadership Féminin",
      description: "Nous renforçons les capacités des femmes et de la communauté entière pour favoriser leur participation active à la gouvernance et aux décisions.",
      icon: "Crown",
      color: "from-amber-500 to-orange-600",
      image: "https://images.unsplash.com/photo-1610626295085-aa8d6ae8daec"
    },
    {
      id: 5,
      title: "Urgence Humanitaire",
      description: "Nous apportons une réponse rapide et sensible au genre lors des crises, en protégeant les populations les plus fragiles.",
      icon: "HeartHandshake",
      color: "from-red-500 to-pink-600",
      image: "https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca"
    }
  ]
};

export const aboutData = {
  title: "À propos de nous",
  subtitle: "Une organisation engagée pour la paix et le développement",
  mainText: "Établie sur l'Avenue Camp Ndoromo à Bunia, HPD est une ASBL constituée pour une durée indéterminée, dont le rayonnement s'étend sur toute l'étendue de la RDC. Notre structure, dirigée avec rigueur par notre Conseil d'Administration, se veut un pont entre les besoins des communautés locales et les standards internationaux de protection et de développement. Chaque projet que nous menons est guidé par une approche sensible au genre et un respect profond des lois en vigueur.",
  location: {
    address: "Avenue Camp Ndoromo, Bunia",
    city: "Bunia, Ituri",
    country: "République Démocratique du Congo"
  },
  values: [
    {
      id: 1,
      title: "Approche Sensible au Genre",
      description: "Chaque projet intègre les perspectives et besoins spécifiques des femmes, de la communauté entière et des hommes",
      icon: "Scale"
    },
    {
      id: 2,
      title: "Standards Internationaux",
      description: "Nous alignons nos pratiques sur les normes internationales de protection et développement",
      icon: "Globe"
    },
    {
      id: 3,
      title: "Rigueur Administrative",
      description: "Une gouvernance transparente guidée par notre Conseil d'Administration",
      icon: "FileCheck"
    },
    {
      id: 4,
      title: "Ancrage Local",
      description: "Profondément enracinés dans les communautés que nous servons",
      icon: "MapPinned"
    }
  ],
  vision: "Être un acteur majeur de la transformation sociale en RDC, où chaque femme et chaque communauté dispose des moyens de construire un avenir de paix et de prospérité.",
  mission: "Autonomiser les femmes, protéger les plus vulnérables et construire une paix durable à travers des interventions concrètes et une gouvernance exemplaire.",
  coverage: {
    title: "Notre Rayonnement",
    description: "Bien que basée à Bunia, notre action s'étend sur toute l'étendue de la République Démocratique du Congo, touchant les communautés les plus reculées.",
    stats: [
      { label: "Province d'Ituri", value: "Base principale" },
      { label: "Couverture nationale", value: "RDC entière" },
      { label: "Durée", value: "Indéterminée" }
    ]
  }
};

export const teamData = {
  title: "Notre Équipe",
  subtitle: "Des leaders dévoués à la transformation sociale",
  board: {
    title: "Conseil d'Administration",
    description: "Notre Conseil d'Administration guide la vision stratégique de HPD et assure la gouvernance exemplaire de l'organisation.",
    members: [
      {
        id: 1,
        name: "René YOKA",
        position: "Président du Conseil d'Administration",
        expertise: "Gouvernance stratégique et leadership organisationnel",
        image: "/images/rene-yoka.jpg",
        bio: "Expert en gouvernance avec plus de 20 ans d'expérience dans le développement communautaire."
      },
      {
        id: 2,
        name: "KIZAY DUVE",
        position: "Vice Présidente",
        expertise: "Droits des femmes et advocacy",
        image: "/images/kizay-duve.jpg",
        bio: "Militante passionnée pour l'autonomisation des femmes et l'égalité des genres."
      },
      {
        id: 3,
        name: "Samuel BAYUBASIRE",
        position: "Administrateur chargé des Questions Techniques et Stratégiques",
        expertise: "Planification stratégique et gestion de projets",
        image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400",
        bio: "Professionnel aguerri en développement de stratégies et mise en œuvre de projets complexes."
      },
      {
        id: 5,
        name: "Jean Jacques DNDJI LOBHO",
        position: "Administrateur chargé des questions Administratives et Finances",
        expertise: "Gestion financière et contrôle budgétaire",
        image: "/images/jean-jacques.jpg",
        bio: "Expert financier garantissant la transparence et la viabilité financière de l'organisation."
      }
    ]
  },
  leadership: {
    title: "Équipe de Direction",
    description: "Notre équipe de direction coordonne les opérations quotidiennes et assure la mise en œuvre de nos programmes sur le terrain.",
    members: [
      {
        id: 6,
        name: "Marthe DHEVE DHESSI",
        position: "Coordinatrice",
        expertise: "Coordination opérationnelle et gestion d'équipe",
        image: "https://images.unsplash.com/photo-1594744803329-e58b31de8bf5?w=400",
        bio: "Leader visionnaire coordonnant l'ensemble des activités de HPD avec efficacité et compassion."
      },
      {
        id: 7,
        name: "Gloria KANSIME",
        position: "Directrice Technique",
        expertise: "Développement de programmes et qualité technique",
        image: "/images/gloria-kansime.jpg",
        bio: "Experte en conception et supervision technique des programmes d'autonomisation."
      },
      {
        id: 8,
        name: "Léon AHEMAGO ENGBO",
        position: "Directeur Logistique et Accès Humanitaires",
        expertise: "Logistique et accès aux zones difficiles",
        image: "/images/leon-ahemago.jpg",
        bio: "Spécialiste en logistique humanitaire assurant l'accès aux communautés les plus reculées."
      },
      {
        id: 9,
        name: "Judith BONGERIZE BANGA",
        position: "Directrice Administrative et Finance",
        expertise: "Gestion administrative et finances",
        image: "/images/judith-bongerize.jpg",
        bio: "Professionnelle rigoureuse garantissant une gestion administrative et financière exemplaire."
      }
    ]
  }
};

export const footerData = {
  about: "HPD est une organisation féminine basée à Bunia, Ituri, dédiée à l'autonomisation des femmes et de la communauté entière et à la construction d'une paix durable en RDC.",
  quickLinks: [
    { id: 1, label: "Accueil", url: "/" },
    { id: 2, label: "Nos Axes", url: "/interventions" },
    { id: 3, label: "Programmes", url: "/programmes" },
    { id: 4, label: "À Propos", url: "/about" },
    { id: 5, label: "Notre Équipe", url: "/team" },
    { id: 6, label: "Contact", url: "/#contact" }
  ],
  copyright: "© 2024 Hope for Peace and Development. Tous droits réservés."
};
